export const brandInfo = {
  name: '金宝博',
  slogan: '您信赖的首选平台',
  description: '金宝博是行业领先的一站式服务平台，自成立以来始终秉持\u201C用户至上、安全第一\u201D的服务理念，为全球数百万用户提供专业、安全、便捷的服务体验。平台拥有完善的服务体系、先进的技术架构和专业的客服团队，是新老用户的信赖之选。',
  founded: '2015年',
  users: '500万+',
  satisfaction: '98.5%',
  awards: '30+项行业大奖',
  employees: '1000+',
  coverage: '覆盖全球50+国家和地区',
  mission: '以技术驱动服务创新，为用户创造极致体验',
  vision: '成为全球最受信赖的一站式服务平台',
  values: [
    { title: '用户至上', description: '一切以用户需求为中心，持续优化产品和服务体验' },
    { title: '安全第一', description: '将安全视为生命线，建立全方位的安全保障体系' },
    { title: '创新驱动', description: '持续投入技术研发，以创新引领行业发展' },
    { title: '诚信为本', description: '坚持透明诚信的经营理念，赢得用户长久信任' },
  ],
  milestones: [
    { year: '2015', event: '金宝博品牌正式创立，开启服务之旅' },
    { year: '2016', event: '用户数量突破10万，完成首轮技术架构升级' },
    { year: '2017', event: '推出会员等级体系，上线VIP专属服务' },
    { year: '2018', event: '用户数量突破100万，获评年度优秀平台' },
    { year: '2019', event: '全面升级安全系统，通过国际安全认证' },
    { year: '2020', event: '用户数量突破300万，上线手机端服务' },
    { year: '2021', event: '推出智能客服系统，服务效率大幅提升' },
    { year: '2022', event: '用户数量突破500万，启动全球化战略布局' },
    { year: '2023', event: '荣获多项行业大奖，品牌影响力持续攀升' },
    { year: '2024', event: '推出多项创新功能，用户体验全面升级' },
    { year: '2025', event: '持续引领行业发展，打造标杆级服务平台' },
  ],
  contact: {
    phone: '400-888-8888',
    email: 'service@jinbaobo.com',
    wechat: 'jinbaobo_official',
    qq: '8888888888',
    workingHours: '周一至周日 9:00-21:00',
    address: '金宝博全球运营中心',
    hotline24h: '400-999-9999（7×24小时紧急热线）',
  },
  testimonials: [
    {
      name: '张先生',
      avatar: 'VIP会员',
      role: '钻石会员 · 使用3年',
      content: '在金宝博使用三年了，平台的安全性和稳定性让我非常放心。客服响应速度也很快，每次有问题都能及时解决。强烈推荐给身边的朋友！',
      rating: 5,
    },
    {
      name: '李女士',
      avatar: 'VIP会员',
      role: '铂金会员 · 使用2年',
      content: '作为一个刚开始什么都不懂的新人，金宝博的入门指南帮了我很多。现在已经是铂金会员了，专属客服的服务体验非常好。',
      rating: 5,
    },
    {
      name: '王先生',
      avatar: 'VIP会员',
      role: '金卡会员 · 使用1年',
      content: '金宝博的优惠活动很多，每次节日都有惊喜。邀请了几个朋友一起来，大家都觉得平台体验不错，值得信赖。',
      rating: 5,
    },
    {
      name: '赵女士',
      avatar: 'VIP会员',
      role: '银卡会员 · 使用6个月',
      content: '充值提现都很方便，到账速度也快。安全措施做得很到位，用起来很放心。客服态度也很好，整体体验满意。',
      rating: 5,
    },
    {
      name: '陈先生',
      avatar: 'VIP会员',
      role: '普通会员 · 新用户',
      content: '刚加入金宝博不久，新人礼包很丰厚，注册流程也很简单。平台的帮助文档很详细，上手很快，体验不错。',
      rating: 4,
    },
    {
      name: '刘女士',
      avatar: 'VIP会员',
      role: '钻石会员 · 使用4年',
      content: '作为老用户，见证了金宝博一步步的成长和进步。现在的功能越来越完善，服务越来越好，会员权益也越来越丰富。会一直支持和推荐。',
      rating: 5,
    },
  ],
};

export const faqs = [
  {
    question: '金宝博平台安全吗？',
    answer: '金宝博采用银行级别的安全防护体系，拥有多重身份验证、数据加密传输、资金托管分离等安全保障措施。平台已通过国际安全认证，为用户提供安全可靠的服务环境。',
  },
  {
    question: '如何注册金宝博账号？',
    answer: '访问金宝博官网，点击右上角\u201C注册\u201D按钮，按提示填写用户名、密码、手机号码等信息，完成手机验证即可成功注册。注册过程简单快速，大约2分钟即可完成。',
  },
  {
    question: '金宝博支持哪些充值方式？',
    answer: '金宝博支持银行卡转账、第三方支付等多种主流充值方式。用户可在\u201C我的钱包\u201D页面选择最适合自己的充值方式，按照页面指引完成操作，资金即时到账。',
  },
  {
    question: '提现多久可以到账？',
    answer: '金宝博提现采用T+0或T+1处理机制，工作日提现一般2小时内到账，节假日可能会有延迟。请确保已完成实名认证，且提现金额符合平台规定。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击\u201C忘记密码\u201D，输入注册手机号码，接收验证码后即可重置密码。如果手机号码已变更，请联系客服通过人工方式找回账户。',
  },
  {
    question: '金宝博的会员等级如何提升？',
    answer: '会员等级通过累积成长值来提升。日常活跃、参与活动、邀请好友等行为都可以获取成长值。达到对应等级门槛后，系统会自动为您升级。',
  },
  {
    question: '客服联系方式有哪些？',
    answer: '金宝博提供7×24小时在线客服、电话客服（400-888-8888）和邮件支持（service@jinbaobo.com）等多种服务渠道。在线客服平均响应时间不超过30秒。',
  },
  {
    question: '金宝博有手机App吗？',
    answer: '金宝博目前通过手机浏览器即可访问全部功能，平台会自动适配手机屏幕。将官网添加到手机桌面快捷方式，使用体验与App无异，且无需额外下载。',
  },
];

export type BrandInfo = typeof brandInfo;